export const LOGIN_FORM = "login";
export const FORGOT_PASSWORD_FORM = "forgotPasswordForm";
export const RESET_PASSWORD_FORM = "resetPasswordForm";
export const TWO_FACTOR_VERIFICATION_FORM = "twoFactorVerificationForm";